import type {
    FreePaymentFulfilled} from "./free-payment-fulfilled";
import {
    freePaymentFulfilledZodSchema,
} from "./free-payment-fulfilled";

type FreePayment = FreePaymentFulfilled;
const freePaymentZodScheme = freePaymentFulfilledZodSchema;

export type { FreePayment };
export { freePaymentZodScheme };
